import AsyncStorage from '@react-native-async-storage/async-storage';
import * as SecureStore from 'expo-secure-store';
import { useCallback, useEffect, useState } from 'react';
import { Platform } from 'react-native';
import 'react-native-get-random-values';
import { v4 as uuidv4 } from 'uuid';

/**
 * Generate a unique Device ID to track the device. The Device ID should persist
 * even if the app is deleted and reinstalled due to use of SecureStore, which
 * utilizes iOS keychain and Android keystore.
 */
export function useDeviceId() {
  const [deviceId, setDeviceId] = useState<string>();
  const getDeviceId = useCallback(async () => {
    let deviceId =
      Platform.OS === 'web'
        ? await AsyncStorage.getItem('deviceId')
        : await SecureStore.getItemAsync('deviceId');
    if (!deviceId) {
      deviceId = uuidv4();
      if (Platform.OS === 'web') {
        await AsyncStorage.setItem('deviceId', deviceId);
      } else {
        await SecureStore.setItemAsync('deviceId', deviceId);
      }
    }
    setDeviceId(deviceId);
    return deviceId;
  }, []);
  useEffect(() => {
    getDeviceId();
  }, [getDeviceId]);
  return { deviceId };
}
